import apiClient from './client';
import type { Domain, DomainWithProject, CreateDomainInput, UpdateDomainInput } from '@/types/domain';

// ========== DOMAINS API ==========

// Listar todos os domínios (filtro opcional por projeto — um id ou vários).
// Vários vão como "4,11,15": o backend aceita a lista no mesmo parâmetro, e a querystring
// não cresce como cresceria repetindo project_id[] por projeto.
export const getDomains = async (projectId?: number | number[]): Promise<Domain[]> => {
    const filtro = Array.isArray(projectId) ? projectId.join(',') : projectId;
    const params = filtro ? { project_id: filtro } : {};
    const response = await apiClient.get<Domain[]>('/domains', { params });
    return response.data;
};

// Obter domínio específico com dados do projeto
export const getDomainById = async (domainId: number): Promise<DomainWithProject> => {
    const response = await apiClient.get<DomainWithProject>(`/domains/${domainId}`);
    return response.data;
};

// Criar novo domínio
export const createDomain = async (data: CreateDomainInput): Promise<Domain> => {
    const response = await apiClient.post<Domain>('/domains', data);
    return response.data;
};

// Atualizar domínio
export const updateDomain = async (domainId: number, data: UpdateDomainInput): Promise<Domain> => {
    const response = await apiClient.put<Domain>(`/domains/${domainId}`, data);
    return response.data;
};

// Deletar domínio (soft delete)
export const deleteDomain = async (domainId: number): Promise<void> => {
    await apiClient.delete(`/domains/${domainId}`);
};

// Verificar disponibilidade de domínio
export const checkDomainAvailability = async (domainName: string): Promise<{ available: boolean; message: string }> => {
    const response = await apiClient.get<{ available: boolean; message: string }>(`/domains/check/${domainName}`);
    return response.data;
};